var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFunnel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 266,
    height: 290,
    viewBox: "0 0 266 290",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#778696",
    d: "M0 0l6.348 70.869 75.507 51.233c16.865 12.462 26.859 32.145 26.963 53.106v74.494L157.182 290V175.208c-.01-20.77 9.697-40.35 26.237-52.925l76.233-52.804L266 0H0zm248.166 62.592l-71.82 49.783c-19.67 14.914-31.232 38.16-31.255 62.833v88.994l-24.182-20.119v-68.875c-.076-24.961-11.957-48.417-32.04-63.256L17.833 63.62 13.36 12.083h239.28l-4.474 50.509z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunnel);
export default __webpack_public_path__ + "static/media/funnel.dc6a4fa8442d2d03f416c81750075260.svg";
export { ForwardRef as ReactComponent };